import {h} from 'preact';
import {useState} from "preact/hooks";


const OnEditControls = ({core}) => {
    const [isPaused, setPause] = useState(false);
    core.surfer.setPause = setPause;
    const playPause = () => {
        core.surfer.playPause();
        setPause(!isPaused)
    };
    const save = () => {
        core.surfer.save();
    };
    const retry = () => {
        core.setView('OnStart');
    };
    return (
        <div className="controls">
            {!isPaused ? (
                <button onClick={playPause}>
                    <img src="https://www.textfromtospeech.com/media/media/play-light_hyPPuS0.svg"
                         alt="Play"
                    />
                </button>
            ) : null}
            {isPaused ? (
                <button onClick={playPause}>
                    <img src="https://www.textfromtospeech.com/media/media/pause-light_F8pxZw9.svg"
                         alt="Pause"
                    />
                </button>
            ) : null}
            <button onClick={save}>
                <img src="https://www.textfromtospeech.com/media/media/download-light_WcFR5Wo.svg"
                     alt="Save"
                />
            </button>
            <button onClick={retry}>
                <img src="https://www.textfromtospeech.com/media/media/clear-light_MRXXwOQ.svg"
                     alt="Save"
                />
            </button>
        </div>
    )
}

const OnEdit = ({core}) => {
    return (
        <div className="on-edit">
            <div className="waveform-container">
                <div id="waveform"/>
            </div>
            <OnEditControls core={core}/>
        </div>
    )
}

export default OnEdit;
